import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';


@Component({
  selector: 'app-file-view',
  templateUrl: './file-view.component.html',
  styleUrls: ['./file-view.component.scss']
})
export class FileViewComponent implements OnInit {

  constructor(
    private activatedRoute:ActivatedRoute,
    private router:Router
  ) { }

  ngOnInit(): void {
    let uuid = this.activatedRoute.snapshot.params['uuid'];
    if(uuid){
      this.router.navigate(['repo/file-view',uuid]);
      // this.router.navigate(['home/repository-report/file-view',uuid]);
    }
  }

}
